import { useQuery } from "@tanstack/react-query";
import {
  getPayPoints,
  getPayPointsMerchantMerchantPublicID,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const PAY_POINTS_QUERY_KEY = "PAY_POINTS";

export const payPointsKeys = {
  all: [PAY_POINTS_QUERY_KEY],
  list: (filters: { offset?: number; limit?: number }) => [
    ...payPointsKeys.all,
    filters,
  ],
  byMerchant: (filters: {
    offset?: number;
    limit?: number;
    merchantPublicID?: string;
  }) => [...payPointsKeys.all, filters],
};

export const usePayPointsQuery = (
  offset: number,
  limit: number,
  merchantPublicID?: string,
) =>
  useQuery({
    queryKey: payPointsKeys.byMerchant({ offset, limit, merchantPublicID }),
    queryFn: processResponseWithApiProblemDetails(() =>
      merchantPublicID
        ? getPayPointsMerchantMerchantPublicID(merchantPublicID, offset, limit)
        : getPayPoints(offset, limit),
    ),
  });
